import { Component, OnInit } from '@angular/core';
import { MessageListOption, Message, MassiveMessage, Canal, Mensaje } from '../../../../api/interfaces/messages';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { RoleString } from 'src/app/enums/role';
import { RolService } from 'src/app/services/rol/rol.service';
import { SnackbarService } from 'src/app/utils/snackbar/snackbar.service';
import { MessagesService } from 'src/app/api/services/messages/messages.service';
import { TrainingDays } from 'src/app/api/interfaces/register';
import { Level, TType } from 'src/app/api/interfaces/user';
import { RegisterService } from 'src/app/api/services/register/register.service';
import { TrainingService } from 'src/app/api/services/training/training.service';

@Component({
  selector: 'app-conversation-massive',
  templateUrl: './conversation-massive.component.html',
  styleUrls: ['./conversation-massive.component.scss']
})
export class ConversationMassiveComponent implements OnInit {

  message: MessageListOption =  null;

  moreMessagesAvalaible: boolean = true;
  showForm: boolean = false;
  isAdmin: boolean = true;
  loaded: boolean = false;

  CANTIDAD_ELEMENTOS: number = 10;
  pagina: number = 0;

  canal: Canal = null;

  // todo: remover mockup
  // messages: MassiveMessage[] = [
  //   { fecha: new Date("2021-12-28T19:58:39.052Z"), asunto: "¡Felices fiestas!", mensaje: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non, veritatis officia iste iusto, fugit labore commodi tempora, incidunt provident ea aut perspiciatis eum omnis et obcaecati aliquam magnam ab praesentium?", etiquetas: [ "ONLINE", "PRESENCIAL", "ENTRENADORES" ], vacaciones: false },
  //   { fecha: new Date("2021-12-28T19:58:39.052Z"), asunto: "¡Felices fiestas!", mensaje: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non, veritatis officia iste iusto, fugit labore commodi tempora, incidunt provident ea aut perspiciatis eum omnis et obcaecati aliquam magnam ab praesentium?", etiquetas: [ "ONLINE", "PRESENCIAL", "ENTRENADORES" ], vacaciones: false },
  //   { fecha: new Date("2021-12-28T19:58:39.052Z"), asunto: "¡Felices fiestas!", mensaje: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non, veritatis officia iste iusto, fugit labore commodi tempora, incidunt provident ea aut perspiciatis eum omnis et obcaecati aliquam magnam ab praesentium?", etiquetas: [ "ONLINE", "PRESENCIAL", "ENTRENADORES" ], vacaciones: true } 
  // ];

  messages: Mensaje [] = [];

  allLevels: Level[] = [];
  allTrainingDays: TrainingDays[] = [];
  allTypes: TType[] = [];

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private rol: RolService,
    private messagesService: MessagesService,
    private snack: SnackbarService,
    private registerService: RegisterService,
    private trainingService: TrainingService
  ) { 
    this.matIconRegistry.addSvgIcon(
      `megaphone`,
      this.domSanitizer.bypassSecurityTrustResourceUrl('../../../../../assets/megaphone.svg')
    );
  }

  ngOnInit(): void {
    this.isAdmin = this.rol.isAdmin();
    this.loadMessages();
  }

  loadMessages() {
    if(this.pagina == 0) {
      this.messages = [];
    }
    this.messagesService.getTodosMensajesMasivos(this.CANTIDAD_ELEMENTOS, this.pagina).subscribe(response => {
      const messages: Mensaje[] = response.content;
      this.moreMessagesAvalaible = false;

      //si pagina es cero quiero que el array sea la respuesta, sino debo agregar mas al final y conservar los anteriores
      if(this.pagina == 0) {
        this.messages = messages.reverse();
      } else {
        messages.forEach(aux => this.messages.unshift(aux));
      }

      if(response.totalPages > (this.pagina + 1)) {
        this.moreMessagesAvalaible = true;
      } else {
        this.moreMessagesAvalaible = false;
      }

      // this.messagesService.getMensajesMasivos(this.CANTIDAD_ELEMENTOS,this.pagina+1).subscribe(response => {
      //   if(response.length > 0) {
      //     this.moreMessagesAvalaible = true;
      //   } else {
      //     this.moreMessagesAvalaible = false;
      //   }
      // }, error => {
      //   console.error(error);
      //   this.snack.snackTranslate('snacks.error.generic');
      // });
      this.getTrainingDays();
    }, error => {
      console.error(error);
      this.snack.snackTranslate('snacks.error.generic');
    });
  }

  newMessageEvent(message: Mensaje) {
    this.messages.push(message);
    this.toggleNewMassive();
  }

  toggleNewMassive() {
    this.showForm = ! this.showForm;
  }

  // todo: remover funcion y verificar en loadMessages
  toggleMoreMessages() {
    this.moreMessagesAvalaible = !this.moreMessagesAvalaible;
  }

  onUpMessages() {
    if(this.moreMessagesAvalaible) {

      this.pagina++;
      this.loadMessages();
      //todo: remover mockup
      // let mensajes: MassiveMessage[] = [
      //   { fecha: new Date("2021-12-28T19:58:39.052Z"), asunto: "SCROLL 1", mensaje: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non, veritatis officia iste iusto, fugit labore commodi tempora, incidunt provident ea aut perspiciatis eum omnis et obcaecati aliquam magnam ab praesentium?", etiquetas: [ "ONLINE"], vacaciones: false },
      //   { fecha: new Date("2021-12-28T19:58:39.052Z"), asunto: "SCROLL 2", mensaje: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non, veritatis officia iste iusto, fugit labore commodi tempora, incidunt provident ea aut perspiciatis eum omnis et obcaecati aliquam magnam ab praesentium?", etiquetas: [ "PRESENCIAL" ], vacaciones: false },
      //   { fecha: new Date("2021-12-28T19:58:39.052Z"), asunto: "SCROLL 3", mensaje: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Non, veritatis officia iste iusto, fugit labore commodi tempora, incidunt provident ea aut perspiciatis eum omnis et obcaecati aliquam magnam ab praesentium?", etiquetas: [ "ONLINE", "PRESENCIAL" ], vacaciones: false } ];
        
        //unshift para agregar al principio
        // this.messages.forEach(mensaje => this.messages.unshift(mensaje));
      }
  }

  closeEvent() {
    this.showForm = false;
  }

  loadLevels() {
    this.trainingService.getLevels().subscribe( response=> {
      this.allLevels = response;
      let remover: number = this.allLevels.findIndex(option => option.id == 1);
      if(remover != -1) {
        this.allLevels.splice(remover, 1);
      }
      this.getTrainingTypes();
    },
    error => {
      console.error(error);
    });
  }

  getTrainingTypes() {
    this.registerService.getTrainingTypes()
    .subscribe(response => {
      this.allTypes= response;
      this.loaded = true;
    },
      error => {
        console.error(error);
      });
  }

  getTrainingDays () {
    this.registerService.getTrainingDays()
    .subscribe(response => {
      this.allTrainingDays = response;
      //remover no definido
      this.allTrainingDays.splice(0,1);
      this.loadLevels();
    },
      error => {
        console.error(error);
      });
  }
}
